import { useSyncExternalStore } from 'react'
import { isPortalNavPending, subscribePortalNav } from '../utils/portalNavQueue'

export function usePortalNavPending(): boolean {
  return useSyncExternalStore(subscribePortalNav, isPortalNavPending)
}
